<template>
  <div class="page-wrapper">
    <!-- ===================== PC 版（折叠搜索栏） ===================== -->
    <div class="pc-version">
      <div
        class="user-charge-table-container"
        v-loading="loading"
        element-loading-text="加载中..."
      >
        <!-- PC 搜索栏（折叠版） -->
        <div
          class="search-bar"
          style="
            margin-bottom: 20px;
            display: flex;
            gap: 10px;
            align-items: center;
            flex-wrap: wrap;
          "
        >
          <div class="search-collapse-btn" @click="toggleSearch">
            <i
              class="el-icon-arrow-down"
              :class="{ 'el-icon-arrow-up': !searchCollapsed }"
            ></i>
            {{ searchCollapsed ? "展开搜索" : "收起搜索" }}
          </div>
          <div
            :style="{
              display: searchCollapsed ? 'none' : 'flex',
              gap: '10px',
              alignItems: 'center',
              flexWrap: 'wrap',
            }"
          >
            <el-input
              v-model="searchParams.user_id"
              placeholder="用户ID"
              style="width: 160px"
              clearable
            ></el-input>

            <el-input
              v-model="searchParams.order_no"
              placeholder="订单号"
              style="width: 220px"
              clearable
            ></el-input>

            <el-select
              v-model="searchParams.status"
              placeholder="支付状态"
              clearable
              style="width: 160px"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.status"
                :label="item.desc"
                :value="item.status"
              ></el-option>
            </el-select>

            <el-select
              v-model="searchParams.pay_type"
              placeholder="支付方式"
              clearable
              style="width: 160px"
            >
              <el-option
                v-for="item in payTypeOptions"
                :key="item.type"
                :label="item.desc"
                :value="item.type"
              ></el-option>
            </el-select>

            <el-input
              v-model="searchParams.transaction_id"
              placeholder="交易号"
              style="width: 240px"
              clearable
            ></el-input>

            <!-- 新增 开始时间 -->
            <el-date-picker
              v-model="searchParams.start_at"
              type="datetime"
              placeholder="开始时间"
              style="width: 200px"
              clearable
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
            <!-- 新增 结束时间 -->
            <el-date-picker
              v-model="searchParams.end_at"
              type="datetime"
              placeholder="结束时间"
              style="width: 200px"
              clearable
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </div>
          <div style="display: flex; gap: 10px; margin-left: 10px">
            <el-button type="primary" @click="getList">搜索</el-button>
            <el-button @click="resetSearch">重置</el-button>
          </div>
        </div>
        <!-- 充值金额汇总统计 -->
        <div class="huizong"
          style="
            background: #fff;
            padding: 16px 20px;
            border-radius: 8px;
            margin-bottom: 16px;
            display: flex;
            gap: 30px;
            flex-wrap: wrap;
            align-items: center;
            border: 1px solid #e6e6e6;
          "
        >
          <div style="font-size: 16px; font-weight: bold;">
            金额汇总：
          </div>
          <div
            v-for="item in groupSumList"
            :key="item.pay_type"
            style="font-size: 15px"
          >
            <span style="color: #666; margin-right: 6px"
              >{{ item.label }}：</span
            >
            <span style="font-size: 18px; color: #f56c6c; font-weight: bold"
              >{{ item.amount }} 元</span
            >
          </div>
        </div>
        <el-table
        height="900"
          :data="tableData"
          border
          stripe
          style="width: 100%"
          @row-click="handleRowClick"
        >
          <el-table-column label="ID" prop="id" width="80" align="center" />
          <el-table-column
            label="用户ID"
            prop="user_id"
            width="120"
            align="center"
          />
          <el-table-column
            label="充值金额"
            prop="amount"
            width="120"
            align="center"
          />
          <el-table-column label="订单号" prop="order_no" min-width="220" />
          <el-table-column
            label="交易号"
            prop="transaction_id"
            min-width="220"
          />

          <el-table-column label="支付状态" width="120" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status === 1 ? 'success' : 'info'">
                {{ scope.row.status_desc }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column
            label="支付方式"
            prop="pay_type_desc"
            width="140"
            align="center"
          />
          <el-table-column label="支付时间" prop="paid_at" width="180" />
          <el-table-column label="创建时间" prop="created_at" width="180" />
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>

        <el-dialog
          title="充值详情"
          :visible.sync="detailVisible"
          width="600px"
          append-to-body
        >
          <el-form :model="detailForm" label-width="120px" size="small">
            <el-form-item label="ID"
              ><span>{{ detailForm.id }}</span></el-form-item
            >
            <el-form-item label="用户ID"
              ><span>{{ detailForm.user_id }}</span></el-form-item
            >
            <el-form-item label="充值金额"
              ><span>{{ detailForm.amount }} 元</span></el-form-item
            >
            <el-form-item label="订单号"
              ><span>{{ detailForm.order_no }}</span></el-form-item
            >
            <el-form-item label="交易号"
              ><span>{{
                detailForm.transaction_id || "无"
              }}</span></el-form-item
            >
            <el-form-item label="支付状态"
              ><span>{{ detailForm.status_desc }}</span></el-form-item
            >
            <el-form-item label="支付方式"
              ><span>{{ detailForm.pay_type_desc }}</span></el-form-item
            >
            <el-form-item label="支付时间"
              ><span>{{ detailForm.paid_at }}</span></el-form-item
            >
            <el-form-item label="创建时间"
              ><span>{{ detailForm.created_at }}</span></el-form-item
            >
            <el-form-item label="更新时间"
              ><span>{{ detailForm.updated_at }}</span></el-form-item
            >
          </el-form>
          <div slot="footer" style="text-align: right">
            <el-button @click="detailVisible = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- ===================== 移动端（折叠搜索栏） ===================== -->
    <div class="mobile-version">
      <div
        class="mobile-container"
        v-loading="loading"
        element-loading-text="加载中..."
      >
        <!-- 移动端搜索栏（折叠版） -->
        <div class="mobile-search">
          <div class="mobile-search-collapse" @click="toggleSearch">
            {{ searchCollapsed ? "展开搜索条件 ▼" : "收起搜索条件 ▲" }}
          </div>
          <div
            v-if="!searchCollapsed"
            style="display: flex; flex-direction: column; gap: 8px"
          >
            <el-input
              v-model="searchParams.user_id"
              placeholder="用户ID"
              clearable
              size="medium"
            ></el-input>
            <el-input
              v-model="searchParams.order_no"
              placeholder="订单号"
              clearable
              size="medium"
            ></el-input>
            <el-select
              v-model="searchParams.status"
              placeholder="支付状态"
              clearable
              size="medium"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.status"
                :label="item.desc"
                :value="item.status"
              ></el-option>
            </el-select>
            <el-select
              v-model="searchParams.pay_type"
              placeholder="支付方式"
              clearable
              size="medium"
            >
              <el-option
                v-for="item in payTypeOptions"
                :key="item.type"
                :label="item.desc"
                :value="item.type"
              ></el-option>
            </el-select>
            <el-input
              v-model="searchParams.transaction_id"
              placeholder="交易号"
              clearable
              size="medium"
            ></el-input>

            <!-- 移动端 开始时间 -->
            <el-date-picker
              v-model="searchParams.start_at"
              type="datetime"
              placeholder="开始时间"
              clearable
              size="medium"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
            <!-- 移动端 结束时间 -->
            <el-date-picker
              v-model="searchParams.end_at"
              type="datetime"
              placeholder="结束时间"
              clearable
              size="medium"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </div>
          <div style="display: flex; gap: 8px; margin-top: 10px">
            <el-button
              type="primary"
              plain
              round
              style="flex: 1"
              @click="getList"
              >搜索</el-button
            >
            <el-button plain round style="flex: 1" @click="resetSearch"
              >重置</el-button
            >
          </div>
        </div>
        <!-- 移动端金额汇总 -->
        <div class="huizong"
          style="
            background: #fff;
            padding: 12px;
            border-radius: 8px;
            margin-bottom: 10px;
          "
        >
          <div  style="font-size: 15px; font-weight: bold; margin-bottom: 8px">
            金额汇总
          </div>
          <div
            v-for="item in groupSumList"
            :key="item.pay_type"
            style="font-size: 14px; line-height: 1.8"
          >
            <span style="color: #666">{{ item.label }}：</span>
            <span style="font-size: 16px; color: #f56c6c; font-weight: bold"
              >{{ item.amount }} 元</span
            >
          </div>
        </div>
        <div class="mobile-card-list">
          <div
            class="mobile-card"
            v-for="item in tableData"
            :key="item.id"
            @click="handleRowClickMobile(item)"
          >
            <div class="card-top">
              <div class="label">订单：{{ item.order_no }}</div>
              <el-tag
                :type="item.status === 1 ? 'success' : 'info'"
                size="mini"
              >
                {{ item.status_desc }}
              </el-tag>
            </div>
            <div class="card-body">
              <div><span>用户ID：</span>{{ item.user_id }}</div>
              <div><span>充值金额：</span>{{ item.amount }} 元</div>
              <div><span>支付方式：</span>{{ item.pay_type_desc }}</div>
              <div><span>交易号：</span>{{ item.transaction_id || "无" }}</div>
              <div><span>支付时间：</span>{{ item.paid_at }}</div>
            </div>
            <div class="card-footer">
              <div>创建：{{ item.created_at }}</div>
            </div>
          </div>
        </div>

        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="prev, pager, next, total"
            :total="total"
            pager-count="2"
            small
          />
        </div>

        <el-dialog
          title="充值详情"
          :visible.sync="detailVisibleMobile"
          width="90%"
          top="8vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <el-form :model="detailForm" label-width="100px" size="small">
            <el-form-item label="ID"
              ><span>{{ detailForm.id }}</span></el-form-item
            >
            <el-form-item label="用户ID"
              ><span>{{ detailForm.user_id }}</span></el-form-item
            >
            <el-form-item label="充值金额"
              ><span>{{ detailForm.amount }} 元</span></el-form-item
            >
            <el-form-item label="订单号"
              ><span>{{ detailForm.order_no }}</span></el-form-item
            >
            <el-form-item label="交易号"
              ><span>{{
                detailForm.transaction_id || "无"
              }}</span></el-form-item
            >
            <el-form-item label="支付状态"
              ><span>{{ detailForm.status_desc }}</span></el-form-item
            >
            <el-form-item label="支付方式"
              ><span>{{ detailForm.pay_type_desc }}</span></el-form-item
            >
            <el-form-item label="支付时间"
              ><span>{{ detailForm.paid_at }}</span></el-form-item
            >
            <el-form-item label="创建时间"
              ><span>{{ detailForm.created_at }}</span></el-form-item
            >
            <el-form-item label="更新时间"
              ><span>{{ detailForm.updated_at }}</span></el-form-item
            >
          </el-form>
          <div slot="footer" style="text-align: right">
            <el-button @click="detailVisibleMobile = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";

export default {
  name: "UserChargeList",
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      // 搜索参数 新增 start_at end_at
      searchParams: {
        page: 1,
        page_size: 10,
        user_id: "",
        order_no: "",
        status: "",
        pay_type: "",
        transaction_id: "",
        start_at: "",
        end_at: "",
      },
      // 下拉选项
      statusOptions: [],
      payTypeOptions: [],
      // 弹窗
      detailVisible: false,
      detailVisibleMobile: false,
      detailForm: {},
      // 搜索折叠
      searchCollapsed: true,

      groupSumList: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取充值列表
    async getList() {
      this.loading = true;
      try {
        const res = await api.users.userCharge({
          params: this.searchParams,
        });
        if (res.data.code == 1000) {
          this.tableData = res.data.data.data;
          this.total = res.data.data.total;
          this.statusOptions = res.data.data.status || [];
          this.payTypeOptions = res.data.data.pay_type || [];
          // 新增开始
          const mapLabel = {
            0: "全部",
            1: "微信",
            2: "微信小程序",
            3: "支付宝",
          };
          this.groupSumList = res.data.data.group_sum.map((item) => {
            return {
              pay_type: item.pay_type,
              amount: item.amount,
              label: mapLabel[item.pay_type],
            };
          });
          // 新增结束
        }
      } finally {
        this.loading = false;
      }
    },

    // PC 行点击
    handleRowClick(row) {
      this.detailForm = { ...row };
      this.detailVisible = true;
    },

    // 移动端点击
    handleRowClickMobile(row) {
      this.detailForm = { ...row };
      this.detailVisibleMobile = true;
    },

    // 重置 清空时间
    resetSearch() {
      this.searchParams = {
        page: 1,
        page_size: 10,
        user_id: "",
        order_no: "",
        status: "",
        pay_type: "",
        transaction_id: "",
        start_at: "",
        end_at: "",
      };
      this.getList();
    },

    // 每页条数
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getList();
    },

    // 页码
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getList();
    },

    // 折叠搜索
    toggleSearch() {
      this.searchCollapsed = !this.searchCollapsed;
    },
  },
};
</script>

<style scoped>
.user-charge-table-container {
  padding: 20px;
}
.mobile-container {
  padding: 12px;
  box-sizing: border-box;
}
.mobile-search {
  background: #fff;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 10px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.card-top .label {
  font-size: 15px;
  font-weight: 500;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.8;
}
.card-body span {
  color: #999;
}
.card-footer {
  margin-top: 10px;
  font-size: 12px;
  color: #999;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/userCharge.vue